module.exports = __webpack_public_path__ + "img/percentage.84424b29.svg";